import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { dmClient } from '../../services/dmClient';
import usePageTitle from '../../hooks/usePageTitle';
import './caseBuilder.css';

export default function ClaimResolutionPage() {
  usePageTitle('Claim resolution');
  const { caseId } = useParams();
  const navigate = useNavigate();
  const [empty, setEmpty] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let cancelled = false;
    dmClient.get(`/case-builder/cases/${caseId}/executions`)
      .then((res) => {
        if (cancelled) return;
        const items = res.data?.data?.items || [];
        const latest = items[0];
        if (latest?.claim_resolution_execution_id) {
          navigate(`/case-builder/${caseId}/runs/${latest.claim_resolution_execution_id}`, { replace: true });
          return;
        }
        setEmpty(true);
      })
      .catch((err) => {
        if (!cancelled) setError(err.response?.data?.error || 'Could not open runs for this case.');
      });
    return () => { cancelled = true; };
  }, [caseId, navigate]);

  async function processCase() {
    setBusy(true);
    setError('');
    try {
      const res = await dmClient.post(`/case-builder/cases/${caseId}/executions`);
      navigate(`/case-builder/${caseId}/runs/${res.data.data.claim_resolution_execution_id}`, { state: { watch: true } });
    } catch (err) {
      setError(err.response?.data?.error || 'Could not start this run.');
      setBusy(false);
    }
  }

  return (
    <div className="cb-page">
      <header className="cb-head">
        <div>
          <h1>Claim resolution</h1>
          <p><Link to="/case-builder">Case Builder</Link></p>
        </div>
      </header>
      {error ? <p className="cb-error">{error}</p> : null}
      {!empty && !error ? <p className="cb-note">Opening the latest run…</p> : null}
      {empty ? (
        <section className="cb-panel">
          <h2>This case has not been processed</h2>
          <p>Process uses the case as it is saved and keeps that snapshot with the result.</p>
          <button type="button" className="dm-btn dm-btn--primary" onClick={processCase} disabled={busy}>Process</button>
        </section>
      ) : null}
    </div>
  );
}
